










import {Component, Vue, Prop} from 'vue-property-decorator'

@Component
export default class PageFooter extends Vue {
  @Prop({required: false}) fixed
  @Prop({required: false}) disabled
  @Prop({required: false}) sign
  @Prop({default: '확인'}) text

  visibleTips: boolean = false

  get customClass() {
    return {
      'is-fixed': Boolean(this.fixed !== undefined),
      'is-sign': Boolean(this.sign !== undefined)
    }
  }

  mounted() {
    this.visibleTips = Boolean(this.$slots.tips)
  }

  updated() {
    this.visibleTips = Boolean(this.$slots.tips)
  }
}
